import React from "react";
import { connect } from "react-redux";
import * as resActions from "../../modules/resources";
import Loader from "Components/loader/Loader";
import { displayFormattedDate } from "Utils/dateFormats";
import withAutoRefresh from "Components/withAutoRefresh";
import PropTypes from "prop-types";

import t from "Utils/translation";
import TranslatedString from "Components/TranslatedString";
import _ from "lodash";
import ButtonBack from "Components/buttonBack/ButtonBack";
import DetailStatus from "Components/detailStatus/DetailStatus";
import DetailInfo from "Components/detailInfo/DetailInfo";
import cx from "classnames";
import s from "./show.scss";

const ContextTypes = {
  router: PropTypes.object,
  isLoggedUserTrial: PropTypes.func,
  getLoggedUser: PropTypes.func,
  getLoggedUserType: PropTypes.func,
  isLoggedUserAdmin: PropTypes.func,
  isMobileDevice: PropTypes.func,
  isMediaMobile: PropTypes.func,
  isMediaSM: PropTypes.func,
  isMediaMD: PropTypes.func,
  isMediaLG: PropTypes.func
};

class EmailShowScreen extends React.Component {
  constructor(props, context) {
    super(props, context);
    const {
      session,
      params,
      location: { pathname },
      location
    } = props;

    const loggedUser = context.getLoggedUser();
    const isLinkedEmailAccount = pathname === "/email_account/settings";

    if (isLinkedEmailAccount) {
      // is managing a linked email account set the account in redux store
      props.setEmailAccount([loggedUser.linked_email_account]);
    }

    const domainCode = props.match.params.domainCode || session.user.domain_code;
    const emailCode = props.match.params.emailCode || session.user.code;

    let baseURLForLinks = `/domains/${domainCode}/email_accounts/${emailCode}`;
    if (context.isLoggedUserAdmin()) {
      baseURLForLinks = `/customers/${props.match.params.customerCode}${baseURLForLinks}`;
    }

    let returnUrl = pathname
      .split("/")
      .slice(0, -2)
      .join("/");

    if (context.getLoggedUserType() === "Postmaster") {
      returnUrl = "/";
    }

    // return to postmasters list if is coming from there
    if (emailCode[0] === "P") {
      returnUrl = "/postmasters";
    }

    const query = _.get(location, "state.prevPagination", "");
    returnUrl += query;

    this.state = {
      domainCode,
      emailCode,
      refreshingPending: false,
      baseURLForLinks,
      returnUrl,
      isLinkedEmailAccount,
      showInfo: this.props.isMediaMobile ? false : true
    };

    this.toggleInfo = this.toggleInfo.bind(this);
    this.goBack = this.goBack.bind(this);
  }

  componentDidMount() {
    if (this.state.isLinkedEmailAccount) {
      const loggedUser = this.context.getLoggedUser();
      this.props.getDomain(loggedUser.linked_email_account.domain_code);

      return;
    }

    this.props.getEmailAccount(this.state.domainCode, this.state.emailCode);
    this.props.getDomain(this.state.domainCode);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isMediaMobile !== this.props.isMediaMobile) {
      this.setState({
        showInfo: this.props.isMediaMobile ? false : true
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const str = "/email_account/settings";

    if (nextProps.location.pathname === str && this.props.location.pathname !== str) {
      const loggedUser = this.context.getLoggedUser();
      this.props.getDomain(loggedUser.linked_email_account.domain_code);
      this.props.getEmailAccount(
        loggedUser.linked_email_account.domain_code,
        loggedUser.linked_email_account.code
      );
      this.setState({ isLinkedEmailAccount: true });
    }
  }

  showSettings() {
    this.props.history.push({
      pathname: `${this.state.baseURLForLinks}/settings`
    });
  }

  toggleInfo() {
    this.setState({ showInfo: !this.state.showInfo });
  }

  renderUpdating() {
    return <Loader msg={<TranslatedString>infoMsg.account.updating</TranslatedString>} />;
  }

  renderSanityCheckFailed() {
    return <Loader msg={<TranslatedString>infoMsg.sanityCheck.failed</TranslatedString>} />;
  }

  goBack() {
    this.props.history.push(this.state.returnUrl);
  }

  render() {
    const loggedUser = this.context.getLoggedUser();
    const isLoggedUserAnEmailAccount = loggedUser.type === "EmailAccount";
    let { emailAccount, isEmailAccountLoading, isDomainLoading, domain } = this.props;

    const { isLinkedEmailAccount, showInfo } = this.state;

    const { isMobileDevice, isMediaMobile, isMediaSM, isMediaMD, isMediaLG } = this.context;

    let content;

    if (isLinkedEmailAccount) {
      isEmailAccountLoading = false;
    }

    if (isEmailAccountLoading || isDomainLoading) {
      return <Loader {...this.props} />;
    }

    if (emailAccount.status === "updating") {
      content = this.renderUpdating();
    }
    if (emailAccount.status === "sanity_check_failed") {
      content = this.renderSanityCheckFailed();
    }

    if (emailAccount.status !== "updating" && emailAccount.status !== "sanity_check_failed") {
      content = this.props.render({
        ...this.props,
        emailAccount: emailAccount,
        isLinkedEmailAccount,
        loggedUserType: this.context.getLoggedUserType()
      });
    }

    return (
      <div className={s.showEmailAccounts}>
        <div className={s.navigation}>
          {!isLoggedUserAnEmailAccount && !isLinkedEmailAccount ? (
            <ButtonBack onClick={this.goBack} />
          ) : (
            <div />
          )}
          <div className={s.viewSectionLabel}>
            {t(
              emailAccount.name === "postmaster"
                ? "section.view.postmaster.settings"
                : "section.view.account.email.settings"
            )}
          </div>
        </div>

        <div className={s.header}>
          <div className={s.wrapTitle}>
            <div className="sectionTitle">
              {emailAccount.lastname
                ? emailAccount.firstname + " " + emailAccount.lastname
                : emailAccount.firstname || emailAccount.name}
            </div>

            {isMediaMobile() && (
              <div className={cx(s.showInfo, "internalLink")} onClick={this.toggleInfo}>
                {showInfo ? t("button.details.hide") : t("button.details.show")}
              </div>
            )}
          </div>

          {showInfo && (
            <div className={s.subtitle}>
              <DetailStatus status={emailAccount.status} />
              <div className="sectionDesc">{emailAccount.email_address}</div>
            </div>
          )}

          {showInfo && (
            <div className={s.info}>
              <DetailInfo label={t("detailInfo.label.code")} info={emailAccount.code} inLine />

              <DetailInfo
                label={t("detailInfo.label.created")}
                info={displayFormattedDate(emailAccount.created_at)}
                inLine
              />

              <DetailInfo
                label={t("detailInfo.label.company")}
                info={domain.company ? domain.company : "–"}
                inLine
              />

              <DetailInfo
                label={t("detailInfo.label.messages.sent")}
                info={emailAccount.outbound_limit_status}
                inLine
              />
              <DetailInfo
                label={t("detailInfo.label.messages.rest")}
                info={displayFormattedDate(emailAccount.reset_outbound_limit_time)}
                inLine
              />
            </div>
          )}
        </div>
        <div className={s.settings}>{content}</div>
      </div>
    );
  }
}

EmailShowScreen.contextTypes = ContextTypes;

const mapStateToProps = state => ({
  session: state.session,
  domain: resActions.getData("domain.data.0", state),
  emailAccount: resActions.getData("email_account.data.0", state),
  isDomainLoading: resActions.isResourceLoading("domain", state),
  isEmailAccountLoading: resActions.isResourceLoading("email_account", state),
  emailOutboundLimits: resActions.getData("outboundLimits.data", state),
  areEmailOutboundLimitsLoading: resActions.isResourceLoading("outboundLimits", state),
  outboundLimits: resActions.getData("outboundLimits.data", state)
});

const mapDispatchToProps = dispatch => ({
  getDomain: code => dispatch(resActions.callApi("getDomain", "domain", code)),
  refreshDomain: code => dispatch(resActions.callApi("refreshDomain", "domain", code)),
  getEmailAccount: (code, codeEmail) =>
    dispatch(resActions.callApi("getEmailAccount", "email_account", code, codeEmail)),
  refreshEmailAccount: (codeDomain, codeEmail) =>
    dispatch(resActions.callApi("refreshEmailAccount", "email_account", codeDomain, codeEmail)),
  setEmailAccount: data => dispatch(resActions.setResource("email_account", data)),
  getEmailOutboundLimits: (codeDomain, codeEmail) =>
    dispatch(resActions.callApi("getEmailOutboundLimits", "outboundLimits", codeDomain, codeEmail))
});

const refreshConditionFunc = props => {
  const statuses = ["activating", "disabling", "enabling", "deleting", "updating"];
  const enqueued = statuses.includes(props.emailAccount.status);
  return enqueued && !props.isEmailAccountLoading;
};

const onRefreshFunc = props => {
  props.refreshEmailAccount(props.domain.code, props.emailAccount.code);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAutoRefresh(EmailShowScreen, refreshConditionFunc, onRefreshFunc));
